import api from './index';

export interface HistoryTrip {
  id: number;
  trip_id: number;
  action: string;
  details?: string;
  vehicle_info?: string;
  employee_info?: string;
  created_at: string;
}

export interface CreateHistoryTripData {
  trip_id: number;
  action: string;
  details?: string;
}

export type UpdateHistoryTripData = Partial<CreateHistoryTripData>;

const baseUrl = '/history-trip';

export const historyTripService = {
  async getAll(): Promise<HistoryTrip[]> {
    const response = await api.get(baseUrl);
    return response.data;
  },
  async create(data: CreateHistoryTripData): Promise<HistoryTrip> {
    const response = await api.post(baseUrl, data);
    return response.data;
  },
  async update(id: number, data: UpdateHistoryTripData): Promise<HistoryTrip> {
    const response = await api.put(`${baseUrl}/${id}`, data);
    return response.data;
  },
  async delete(id: number): Promise<void> {
    await api.delete(`${baseUrl}/${id}`);
  },
};
